import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import BulkImportExport from "../../components/BulkImportExport"
import { usePermissions } from "API/PermissionContext"

const TAB_CONFIG = {
  1: { name: "Brands", api: "materials", createApi: "create-material", deleteApi: "delete-material/", addRoute: "/add-material", editRoute: "/edit-material/" },
  2: { name: "Categories", api: "categories", createApi: "create-category", deleteApi: "delete-category/", addRoute: "/add-material-category", editRoute: "/edit-material-category/" },
  3: { name: "Items", api: "material-items", createApi: "create-material-item", deleteApi: "delete-material-item/", addRoute: "/add-material-item", editRoute: "/edit-material-item/" },
}

const COLUMNS = {
  1: [{ key: "materialName", label: "Brand Name", required: true }],
  2: [{ key: "materialCategory", label: "Category Name", required: true }],
  3: [
    { key: "category", label: "Category", required: true },
    { key: "itemName", label: "Item Name", required: true },
    { key: "brand", label: "Brand", required: true },
    { key: "price", label: "Price", required: true },
    { key: "unitType", label: "Unit Type", required: true },
  ],
}

const SAMPLES = {
  1: [{ materialName: "Sample Brand" }],
  2: [{ materialCategory: "Sample Category" }],
  3: [{ category: "1", itemName: "Sample Item", brand: "1", price: "100", unitType: "1" }],
}

const Materials = () => {
  const { canAdd, canEdit, canDelete, canExport, MODULE } = usePermissions()
  const MID = MODULE.MATERIALS
  const [materials, setMaterials] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [tab, setTab] = useState(1)
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [materialId, setMaterialId] = useState("")
  const [search, setSearch] = useState("")
  const [showFilter, setShowFilter] = useState(false)

  const config = TAB_CONFIG[tab]

  const fetchData = useCallback(async () => {
    setDataLoaded(false)
    setCheckedItems({})
    setParentChecked(false)
    try {
      const resp = await api.get(config.api)
      setMaterials(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [config.api])

  useEffect(() => { fetchData() }, [fetchData])

  const handleDelete = async () => {
    try { await api.delete(config.deleteApi + materialId); fetchData() } catch (e) { console.error(e) }
  }
  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try {
      await Promise.all(ids.map(id => api.delete(config.deleteApi + id)))
      setCheckedItems({}); setParentChecked(false); fetchData()
    } catch (e) { console.error(e) }
  }
  const handleCheckbox = id => {
    setCheckedItems(prev => {
      const n = { ...prev, [id]: !prev[id] }
      setParentChecked(materials.length > 0 && materials.every(p => n[p.id]))
      return n
    })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n)
    const items = {}; materials.forEach(p => { items[p.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  const filtered = useMemo(() => {
    if (!search) return materials
    const s = search.toLowerCase()
    return materials.filter(m => {
      if (tab === 1) return (m.materialName || "").toLowerCase().includes(s)
      if (tab === 2) return (m.materialCategory || "").toLowerCase().includes(s)
      return (
        (m.categoryName || m.category || "").toLowerCase().includes(s) ||
        (m.itemName || "").toLowerCase().includes(s) ||
        (m.brandName || m.brand || "").toLowerCase().includes(s) ||
        (m.unitTypeName || m.unitType || "").toLowerCase().includes(s)
      )
    })
  }, [materials, search, tab])

  const switchTab = (t) => { setTab(t); setSearch(""); setShowFilter(false) }

  const actionBtnStyle = (bg) => ({
    width: "28px", height: "28px", borderRadius: "4px", background: bg, color: "#fff",
    border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer"
  })

  const colSpan = tab === 3 ? 8 : 4

  const summaryCards = [
    { label: `Total ${config.name}`, value: materials.length, icon: tab === 1 ? "fa-tags" : tab === 2 ? "fa-th-large" : "fa-boxes", color: "#6366f1" },
  ]

  return (
    <>
      {/* Tab Switcher */}
      <div className="incentivePanel">
        {[1, 2, 3].map(t => (
          <span key={t} onClick={() => switchTab(t)}
            className={tab === t ? "acActive" : ""}
            style={{ cursor: "pointer" }}>
            {TAB_CONFIG[t].name}
          </span>
        ))}
      </div>

      <div className="dashBody" style={{ marginTop: "10px" }}>
        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 style={{ margin: 0 }}>{config.name}</h4>
            {canAdd(MID) && (
              <Link to={config.addRoute} title={`Add ${config.name}`}
                style={{ ...actionBtnStyle("#28a745"), textDecoration: "none", width: "32px", height: "32px", fontSize: "14px" }}>
                <i className="fas fa-plus"></i>
              </Link>
            )}
            {canDelete(MID) && (
              <button title={selectedCount > 0 ? `Delete ${selectedCount} selected` : "Select items to delete"}
                onClick={() => { if (selectedCount > 0) setconfirm_multiple_alert(true); else alert("Please select at least one item to delete.") }}
                style={{ ...actionBtnStyle("#dc3545"), width: "32px", height: "32px", fontSize: "14px", opacity: selectedCount > 0 ? 1 : 0.7 }}>
                <i className="fas fa-trash"></i>
              </button>
            )}
            <button title="Toggle Filter" onClick={() => setShowFilter(!showFilter)}
              style={{ ...actionBtnStyle("#0d6efd"), width: "32px", height: "32px", fontSize: "14px" }}>
              <i className="fas fa-filter"></i>
            </button>
            <BulkImportExport
              data={materials}
              columns={COLUMNS[tab]}
              sampleData={SAMPLES[tab]}
              apiEndpoint={config.createApi}
              entityName={`Material_${config.name}`}
              onImportComplete={fetchData}
              showExport={canExport(MID)}
              showImport={canAdd(MID)}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input type="text" className="form-control form-control-sm" placeholder="Search"
              style={{ width: "180px", borderRadius: "4px 0 0 4px" }}
              value={search} onChange={e => setSearch(e.target.value)} />
            <button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: "31px" }}>
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        {/* Summary Cards */}
        <Row className="mb-3 mt-2">
          {summaryCards.map((card, i) => (
            <Col md={3} sm={6} key={i}>
              <div style={{
                background: "#fff", borderRadius: "10px", padding: "14px 16px",
                borderLeft: `4px solid ${card.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px"
              }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: card.color + "15",
                  display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={`fas ${card.icon}`} style={{ color: card.color, fontSize: "16px" }}></i>
                </div>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>{card.value}</div>
                  <div style={{ fontSize: "11px", color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.5px" }}>{card.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>#</th>
                {tab === 1 && <th>Brand Name</th>}
                {tab === 2 && <th>Category Name</th>}
                {tab === 3 && <><th>Category</th><th>Item Name</th><th>Brand</th><th>Price</th><th>Unit Type</th></>}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  {tab === 1 && <td><input type="text" className="form-control form-control-sm" placeholder="Filter brand..." value={search} onChange={e => setSearch(e.target.value)} /></td>}
                  {tab === 2 && <td><input type="text" className="form-control form-control-sm" placeholder="Filter category..." value={search} onChange={e => setSearch(e.target.value)} /></td>}
                  {tab === 3 && <>
                    <td><input type="text" className="form-control form-control-sm" placeholder="Category..." value={search} onChange={e => setSearch(e.target.value)} /></td>
                    <td></td><td></td><td></td><td></td>
                  </>}
                  <td></td>
                </tr>
              )}
              {dataLoaded ? (
                filtered.length > 0 ? filtered.map((data, i) => (
                  <tr key={data.id}>
                    <td><input type="checkbox" checked={!!checkedItems[data.id]} onChange={() => handleCheckbox(data.id)} /></td>
                    <td>{i + 1}</td>
                    {tab === 1 && <td style={{ fontWeight: 600 }}>{data.materialName}</td>}
                    {tab === 2 && <td style={{ fontWeight: 600 }}>{data.materialCategory}</td>}
                    {tab === 3 && <>
                      <td><span style={{ background: '#6366f115', color: '#6366f1', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{data.categoryName || data.category}</span></td>
                      <td style={{ fontWeight: 600 }}>{data.itemName}</td>
                      <td><span style={{ background: '#0ea5e915', color: '#0ea5e9', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{data.brandName || data.brand}</span></td>
                      <td><span style={{ fontFamily: 'monospace', fontWeight: 600, color: '#16a34a' }}>₹{data.price || 0}</span></td>
                      <td><span style={{ background: '#f59e0b15', color: '#f59e0b', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>{data.unitTypeName || data.unitType}</span></td>
                    </>}
                    <td>
                      <div style={{ display: "flex", gap: "3px" }}>
                        {canEdit(MID) && <Link title="Edit" to={config.editRoute + data.id} style={actionBtnStyle("#0d6efd")}>
                          <i className="fas fa-edit"></i></Link>}
                        {canDelete(MID) && (
                          <button title="Delete" onClick={() => { setMaterialId(data.id); setconfirm_alert(true) }} style={actionBtnStyle("#dc3545")}>
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={colSpan} className="text-center py-4">
                    <i className="fas fa-boxes fa-2x text-muted mb-2 d-block"></i>No {config.name.toLowerCase()} found
                  </td></tr>
                )
              ) : (
                <tr><td colSpan={colSpan}><img className="loaderImg" src={loader} alt="loading" /></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Item deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title={`Delete ${selectedCount} items?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleMultiDelete(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Items deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default Materials
